import React from 'react';

export const GenericErrorSvg: React.FC<{ className?: string }> = ({ className = 'w-72 h-48 sm:w-96 sm:h-64' }) => {
  return (
    <svg
      viewBox="0 0 500 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} mx-auto transition-all duration-300`}
    >
      {/* Background tracks */}
      <rect x="130" y="80" width="240" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />
      <rect x="90" y="115" width="320" height="14" rx="7" fill="#F1F5F9" className="dark:fill-slate-800/60" />
      <rect x="160" y="150" width="180" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />

      {/* Warning Triangle & Exclamation Mark */}
      <g transform="translate(250, 145)">
        <polygon
          points="0,-65 75,55 -75,55"
          stroke="currentColor"
          strokeWidth="16"
          strokeLinejoin="round"
          fill="none"
          className="text-slate-900 dark:text-white"
        />
        <line
          x1="0"
          y1="-20"
          x2="0"
          y2="15"
          stroke="#ef4444"
          strokeWidth="14"
          strokeLinecap="round"
        />
        <circle cx="0" cy="35" r="8" fill="#ef4444" />
      </g>
    </svg>
  );
};

export default GenericErrorSvg;
